import React from 'react'
import Text from '../text'
import * as styles from './NoDealsInfo.css'

export const NoDealsInfo = ({ header, description }) => {
  header = header ? header : 'No deals found'

  return (
    <div className={styles.noDealsInfo}>
      <Text color='#2C3E50' bold size='1.3'>
        {header}
      </Text>
      <Text color='#808080'>{description}</Text>
    </div>
  )
}
